import { ButtonList } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { Category } from 'lib-knowledge-management-common/models/types';
import { useModal } from 'lib-knowledge-modal';

import styles from '../../../editDeleteDropdown/dropdownContext.module.scss';

import { CategoryDeleteModal } from './modals/categoryDeleteModal';
import { CategoryEditModal } from './modals/categoryEditModal';
import { CategoryMoveModal } from './modals/categoryMoveModal';
import s from './styles.module.scss';

function CategoryMenu({
  category,
}: {
  category: Category;
  depth: number;
}): JSX.Element {
  const { showModal } = useModal();

  return (
    <ButtonList>
      <div className={s.buttonGroup}>
        <ButtonList.Item
          icon="pen"
          onClick={() =>
            showModal(CategoryEditModal, {
              categoryId: category.id,
            })
          }
        >
          Edit category
        </ButtonList.Item>
        <ButtonList.Item
          icon="arrow-right"
          onClick={() =>
            showModal(CategoryMoveModal, { categoryId: category.id })
          }
        >
          Move category
        </ButtonList.Item>
        <ButtonList.Item
          className={cx(styles.buttonListItem, styles.deleteItem)}
          icon="trash"
          onClick={() =>
            showModal(CategoryDeleteModal, { categoryId: category.id })
          }
        >
          Delete category
        </ButtonList.Item>
      </div>
    </ButtonList>
  );
}

export default CategoryMenu;
